var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00201 13.8665C6.58323 13.8708 5.21154 13.3578 4.1437 12.4236C3.07587 11.4894 2.3851 10.1981 2.20071 8.79134C2.14089 8.33501 1.72247 8.01357 1.26614 8.07338C0.809804 8.1332 0.488362 8.55162 0.548178 9.00795C0.785256 10.8166 1.67339 12.4769 3.04631 13.678C4.41924 14.8791 6.18285 15.5386 8.00699 15.5332C9.83113 15.5277 11.5908 14.8576 12.9565 13.6484C14.3222 12.4391 15.2004 10.7735 15.4266 8.96346C15.6529 7.1534 15.2117 5.32292 14.1857 3.81467C13.1597 2.30643 11.6191 1.22383 9.85245 0.769526C8.08577 0.315219 6.21408 0.520351 4.58775 1.34653C3.79785 1.74779 2.9448 2.30651 2.20778 3.00012V1.39965C2.20778 0.939409 1.83468 0.566312 1.37444 0.566312C0.914206 0.566312 0.54111 0.939409 0.54111 1.39965V5.56631C0.54111 6.02655 0.914206 6.39965 1.37444 6.39965H5.54111C6.00135 6.39965 6.37444 6.02655 6.37444 5.56631C6.37444 5.10608 6.00135 4.73298 5.54111 4.73298H2.8564C3.50057 3.96937 4.41341 3.30448 5.3426 2.83245C6.60752 2.18987 8.06328 2.03033 9.43736 2.38368C10.8114 2.73703 12.0096 3.57905 12.8077 4.75212C13.6057 5.9252 13.9488 7.34891 13.7729 8.75674C13.5969 10.1646 12.9138 11.46 11.8516 12.4005C10.7894 13.3411 9.42079 13.8623 8.00201 13.8665Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/retry.fe0cca5d7c1b34af74b1a23baf86ab72.svg";
export { ForwardRef as ReactComponent };